/**
 * Route Constants
 * Centralized route definitions to avoid magic strings
 */

export const ROUTES = {
    HOME: '/',
    COLLECTIONS: '/collections',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    DASHBOARD_UPLOAD: '/dashboard/upload',
};

export default ROUTES;
